import { Layout, Title, Paragraph } from 'components';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@bb/elements-web';
import { SupraLogo } from 'components/SideMenu/StyledComponents';
import logo from '../../../img/logo_v2.svg';
import errorImage from '../../../img/error_screen.svg';

const refresh = () => window.location.reload();

const CompleteFailureScreen: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    history.listen(() => {
      window.location.reload();
    });
  }, []);

  return (
    <Layout>
      <StyledContent>
        <SupraLogo />
        <div className="wrapper">
          <div className="illustration"></div>
          <Title>Uh oh, something&apos;s wrong</Title>
          <Paragraph>There was an error handling your request</Paragraph>
          <Button
            dataCy="reload-page-button"
            onClick={refresh}
            styleOverride={{ minWidth: '130px' }}
          >
            Reload Page
          </Button>
        </div>
      </StyledContent>
    </Layout>
  );
};

const StyledContent = styled(Layout.Content)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  min-height: 100vh;
  padding: 22px 40px;
  background-color: #fafafa;

  .brokerbay-logo {
    width: 100%;
    max-width: 130px;
    padding: 10px;
    margin-bottom: 145px;
    background-image: url(${logo});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .illustration {
    width: 100%;
    max-width: 218px;
    height: 137px;
    margin-bottom: 24px;
    background-image: url(${errorImage});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
  }

  .ant-btn {
    margin-top: 24px;
    font-weight: 400;
  }
`;

export default CompleteFailureScreen;
